import { createTheme } from "@mui/material/styles";
import { fontFamily, palette, radius } from "./tokens";

export { colors, cssVariables, layout, palette, radius } from "./tokens";

export const muiTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: palette.blue500,
      dark: palette.blue400,
      light: palette.blue100,
      contrastText: palette.white,
    },
    secondary: {
      main: palette.gold600,
      light: palette.gold100,
      contrastText: palette.white,
    },
    error: {
      main: palette.red600,
      light: palette.red100,
      contrastText: palette.white,
    },
    warning: { main: palette.gold600, light: palette.gold100 },
    info: { main: palette.blue500, light: palette.blue100 },
    success: { main: palette.blue500, light: palette.blue100 },
    text: {
      primary: palette.grey900,
      secondary: palette.grey700,
      disabled: palette.grey500,
    },
    background: { default: palette.grey100, paper: palette.white },
    divider: palette.grey200,
    action: { hover: palette.blue050, selected: palette.blue100 },
  },
  shape: { borderRadius: radius.control },
  typography: {
    fontFamily,
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: radius.control } },
    },
    MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
    MuiTableCell: {
      styleOverrides: {
        root: { borderBottomColor: palette.grey200 },
        head: {
          backgroundColor: palette.grey050,
          color: palette.blue500,
          fontWeight: 800,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:hover > td": { backgroundColor: palette.rowHover },
          "&.Mui-selected > td": { backgroundColor: palette.blue100 },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: { borderColor: palette.grey250 },
      },
    },
    MuiTooltip: {
      styleOverrides: { tooltip: { backgroundColor: palette.ink } },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: palette.grey250,
          "&.Mui-checked": { color: palette.blue500 },
        },
      },
    },
  },
});

export const antdTheme = {
  token: {
    colorPrimary: palette.blue500,
    colorPrimaryHover: palette.blue400,
    colorPrimaryBg: palette.blue100,
    colorError: palette.red600,
    colorErrorBg: palette.red100,
    colorWarning: palette.gold600,
    colorInfo: palette.blue500,
    colorText: palette.grey900,
    colorTextSecondary: palette.grey700,
    colorTextTertiary: palette.grey500,
    colorBorder: palette.grey250,
    colorBorderSecondary: palette.grey200,
    colorBgContainer: palette.white,
    colorBgLayout: palette.grey100,
    colorBgElevated: palette.white,
    borderRadius: radius.control,
    borderRadiusLG: radius.card,
    borderRadiusSM: radius.small,
    fontFamily,
  },
  components: {
    Table: {
      headerBg: palette.grey050,
      headerColor: palette.blue500,
      rowHoverBg: palette.rowHover,
      rowSelectedBg: palette.blue100,
      rowSelectedHoverBg: palette.blue100,
      borderColor: palette.grey200,
    },
  },
};
